// extracted by mini-css-extract-plugin
export var wrapper = "SideBarDonate-module--wrapper--1OBx-";
export var container = "SideBarDonate-module--container--11mkB";
export var highlight = "SideBarDonate-module--highlight--3aOSQ";
export var amount = "SideBarDonate-module--amount--2Xixy";
export var information = "SideBarDonate-module--information--3l-q2";
export var goal = "SideBarDonate-module--goal--3iYTF";
export var current = "SideBarDonate-module--current--3Wny1";
export var barometer = "SideBarDonate-module--barometer--120Ze";